import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';

function Firstpic() { 
  return (
   <div>
       <Container>        
<Row>
<Col xs={12} sm={6} md={4} lg={3}>
  <div className="box-cont">
  <div className="img-box"><a href="/green"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3218_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /></a> </div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div>

  </Col>
  <Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3219_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
<Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/3/23-3030-1_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col> 

<Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3237_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
  
</Row>
</Container>
<Container>

        
<Row>
<Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3237_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
<Col xs={12} sm={6} md={4} lg={3}>
  <div className="box-cont">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3228_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div>

  </Col>
  <Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3239_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
  <Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3237_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>

</Row>
</Container>
<Container>

        
<Row>
<Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3237_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
<Col xs={12} sm={6} md={4} lg={3}>
  <div className="box-cont">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3240_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div>

  </Col>
  <Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3226_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
  <Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3229_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>

</Row>
</Container>
<Container>        
<Row>
<Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3237_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
<Col xs={12} sm={6} md={4} lg={3}>
  <div className="box-cont">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3223_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div>

  </Col>
  <Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3233_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
  <Col xs={12} sm={6} md={4} lg={3}> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/5/25-3238_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>

</Row>
</Container>
<Useletter/>
<Foter/>

    </div>
  )
}

export default Firstpic
